import { AfterViewInit, Component, ComponentRef, ElementRef, HostBinding, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { PreviewContentComponent } from './preview/preview-content/preview-content.component';
import { PreviewComponent } from './preview/preview.component';
import { LayoutEditorService } from './editors/layout-editor/layout-editor.service';
import { Subject, Subscription, from } from 'rxjs';
import { filter, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { Page, PageType, Section, Site, SiteEditorConfig } from './editor-container/editor-model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SiteConfigListenerService } from './services/site-config-listener.service';
import { CssServicesService } from './services/css-services.service';
import { IframeCommunicationService } from './services/iframe-communication.service';
import { SectionEditorBridgeService } from './services/section-editor-bridge.service';
import { DimensionsService } from './services/dimensions.service';
import { PreviewEditStoreService } from './services/preview-edit-store.service';
import { GridCell, RowCell } from '@urbannex/storethemes';
import { EditState } from './model';
import { PREVIEW_URL_TOKEN } from './injection-tokens';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'kve-preview-container',
  templateUrl: './preview-container.component.html',
  styleUrls: ['./preview-container.component.scss']
})
/**
 * Class is used to send updates to the PreviewComponent
 * Subscribes to obsevrables in the PreviewEditStore and passes it on to the PreviewComponent
 * using the IframeCommunicationService class.
 */
export class PreviewContainerComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private destroy$: Subject<void> = new Subject<void>();
  editState$: Subscription;
  siteConfig$: Subscription;
  layoutSubscription: Subscription;
  targetScreenWidth$: Subscription;
  colorSubscription: Subscription;
  borderSubscription: Subscription;
  sectionSubscription: Subscription;
  selectedSection$: Subscription;
  deleteSectionSubsciption: Subscription;
  showSection$: Subscription;
  hideSection$: Subscription;
  editSection$: Subscription;
  sectionThumbnails$: Subscription;
  cellIdsThumbs$: Subscription;
  selectedCell$: Subscription;
  frameHeight$: Subscription;
  scrollAdjustment$: Subscription;
  // editModel$ = from(this.previewEditStoreService.editModel$);

  readonly editModel$ = this.previewEditStoreService.editModel$.pipe(
    takeUntil(this.destroy$),
    map(editmodel => editmodel))

  readonly pageEditState$ = this.previewEditStoreService.pageEditState$.pipe(
    takeUntil(this.destroy$),
    map(editmodel => editmodel))

  cellLayoutThumbs$: Subscription;

  sites: Site[];
  selectedPage$: Subscription;
  pageBgColor$: Subscription;
  txtColor$: Subscription;
  borders$: Subscription;
  backgrounds$: Subscription;
  colorScheme$: Subscription;
  fontFamilies$: Subscription;



  @ViewChild('iframe', { static: false }) iframe: HTMLIFrameElement;
  @HostBinding("style.--preview-sections-height") contentHeight: string;
  doc: any;
  iframeBody: Element;
  targetScreenWidth: number;
  viewPortHeight: number;

  editState: EditState;
  selectedSite: Site = null;
  selectedPage: Page;
  selectedCell: GridCell | RowCell;


  /* compRef: ComponentRef<PreviewContentComponent>;
  currentComp: Type<PreviewComponent>; */
  currentRoute: string;
  compRef: ComponentRef<PreviewComponent>;

  sanitizedPreviewUrl: SafeResourceUrl;

  constructor(
    @Inject(PREVIEW_URL_TOKEN) public previewUrl: string,
    private sanitizer: DomSanitizer,
    private layoutEditorService: LayoutEditorService,
    // private siteConfigListenerService:SiteConfigListenerService,
    private previewEditStoreService: PreviewEditStoreService,
    private cssServices: CssServicesService,
    private sectionEditorBridgeService: SectionEditorBridgeService,
    private vcRef: ViewContainerRef,
    private communicator: IframeCommunicationService,
    private dimensionsService: DimensionsService,
    private el: ElementRef) {
    console.log({ "PreviewUrl": this.previewUrl })
    this.sanitizedPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewUrl);
    // console.log({"PreviewUrl":this.previewUrl});
    /* router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url)
    )
    .subscribe(url => {
      let route = url.split('?')[0].split('/').pop()
      console.log(route);
      switch (route) {
        case "home-page":
          siteConfigListenerService.setSelectedPageType(PageType.HOME);
          //this.currentRoute = PageType.HOME;
          break;
        case "category-page":
          siteConfigListenerService.setSelectedPageType(PageType.PRODUCT_CATEGORY);
          this.previewEditStoreService.updatePageType(PageType.PRODUCT_CATEGORY);
        default:
          siteConfigListenerService.setSelectedPageType(PageType.HOME);
          break;
      }
    }); */
    this.siteConfig$ = this.previewEditStoreService.siteEditorSitesState$.pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        console.log(data);
        if (data != null && data != undefined) {
          console.log(data)
          this.sites = data;
          // console.log(data);
          this.previewEditStoreService.selectedSite$.subscribe((selectedSite: Site) => {
            console.log(selectedSite);
            if (selectedSite == undefined) {
              if (this.sites.length > 0) {
                console.log("sending site data", this.sites[0])
                this.previewEditStoreService.setSelectedSite(this.sites[0]);
                // this.communicator.sendFromParent({id:"selectedSite",data:this.sites[0]});
              }
            }

          });
          console.log("sending siteConfig", data)
          this.communicator.sendFromParent({ id: "siteConfig", data: data })
        }
      })

  }

  ngOnInit(): void {

    this.editModel$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
      this.editState = data.editState;
      this.previewEditStoreService.selectedPage$.subscribe((page: Page) => {
        console.log("Subscribed Page:", page);
        if (page != null && page != undefined) {
          this.communicator.sendFromParent({ id: "updateSelectedPage", sections: page.sections });
        }
      })
      /* if(data.selectedSite != undefined){
        console.log(this.editState);
        console.log("Sending selected site",data.selectedSite);
        this.communicator.sendFromParent({id:"selectedSite",data:this.selectedSite});
        console.log("Sending selected page",data.selectedPage);
        this.communicator.sendFromParent({id:"selectedPage",data:data.selectedPage});
        this.selectedSite = data.selectedSite;

      } */
    })
    this.selectedPage$ = this.previewEditStoreService.selectedPage$.pipe(takeUntil(this.destroy$))
      .subscribe((page: Page) => {
        console.log(page);
        if (page != null && page != undefined) {
          this.communicator.sendFromParent({ id: "selectedPage", data: page });
        }

      })

    this.pageEditState$.pipe(takeUntil(this.destroy$)).subscribe(editModel => {
      console.log(editModel)
      if (editModel == EditState.UPDATED) {
        this.previewEditStoreService.selectedPage$.subscribe((page: Page) => {
          if (page != null && page != undefined) {
            this.communicator.sendFromParent({ id: "updateSelectedPage", sections: page.sections });
          }
        })
      }
    })
    this.scrollAdjustment$ = this.communicator.receive('adjust-scroll-for-header')
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log('Received scroll adjustment request:', data);
        this.adjustScrollForHeader();
      });


    /* this.editState$ = this.previewEditStoreService.editState$.pipe(
      tap((_editState:EditState) => {
        console.log(_editState)
        this.editState = _editState}),
      switchMap(_editState =>
          this.previewEditStoreService.selectedSite$.pipe(
            tap((site:Site) => {
              console.log(site)
              this.selectedSite = site;
              if(site != undefined){
                console.log("Sending selected site",site);
                this.communicator.sendFromParent({id:"selectedSite",data:site});
                this.previewEditStoreService.selectedPage$.subscribe((page) => {
                  if(this.selectedPage != page){
                    this.selectedPage = page;
                    this.communicator.sendFromParent({id:"updateSelectedPage",sections:page.sections});
                  }
                })
              }
            }),
            )
        //}
        //return _editState
      ),takeUntil(this.destroy$)).subscribe() */
    /* .subscribe((_editState:EditState) => {
      if(_editState == EditState.EDITING){
        console.log("EditState updated Listener ...")
        this.previewEditStoreService.selectedSite$.subscribe((site:Site) => {
          console.log("Sending selected site",site);
          if(site != undefined){
            this.communicator.sendFromParent({id:"selectedSite",data:site});
          }
        })
        this.previewEditStoreService.selectedPage$
          .subscribe((page:Page) => {
            console.log(page)
            if(page != undefined){
              console.log(page);
              this.communicator.sendFromParent({id:"updateSelectedPage",sections:page.sections});
              //console.log(page.sections);
            }else{
              this.previewEditStoreService.siteEditorSitesState$.subscribe(siteConfig => {
                console.log(siteConfig);
                 this.previewEditStoreService.selectedSite$.subscribe(site => {
                   this.communicator.sendFromParent({id:"selectedSite",data:site});
                 })
               })
            }
        })
      }
    }) */
    this.cssServices.init();
    this.selectedCell$ = this.previewEditStoreService.selectedCell$.subscribe(cell => {
      // console.log(cell)
      this.previewEditStoreService.editState$.subscribe(_editState => {
        if (_editState == EditState.EDITING) {
          this.previewEditStoreService.selectedPage$.subscribe((page: Page) => {
            if (page != null && page != undefined) {
              this.communicator.sendFromParent({ id: "updateSelectedPage", sections: page.sections });
            }
          })
        }
      })

    })




    this.sectionSubscription = this.communicator.receive("sections").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        // console.log(data);
        this.sectionEditorBridgeService.setSectionElements(data["data"]['options']);
      })
    this.selectedSection$ = this.sectionEditorBridgeService.getSelectedSection().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        // console.log(data)
        this.communicator.sendFromParent({ id: "selectedElId", "data": data })
      })
    this.deleteSectionSubsciption = this.sectionEditorBridgeService.getDelSectionElement().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.communicator.sendFromParent({ id: "delectedElId", "data": data });
      })
    this.hideSection$ = this.sectionEditorBridgeService.getHidden().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.communicator.sendFromParent({ id: "hideEl", "data": data })
      })
    this.showSection$ = this.sectionEditorBridgeService.getShown().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.communicator.sendFromParent({ id: "showEl", "data": data })
      })
    this.editSection$ = this.sectionEditorBridgeService.getEditElement().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.communicator.sendFromParent({ id: "editEl", data: data })
      })
    this.sectionThumbnails$ = this.communicator.receive("thumbs").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.sectionEditorBridgeService.setSectionThumbnails(data["data"]);
      })
    this.cellIdsThumbs$ = this.communicator.receive("cellIdsThumbs").pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log(data)
        this.sectionEditorBridgeService.setCellIdsThumbs(data['data']);
      });



  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.

    this.frameHeight$ = this.communicator.receive('contentHeight').pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        // console.log(data);
        if (data != undefined) {
          const height = data['data'] + 200;
          this.contentHeight = height + "px";
          // this.iframe.style.setProperty('height',height+"px");
        }
      })
    this.layoutSubscription = this.layoutEditorService.getPallette().pipe(takeUntil(this.destroy$)).subscribe(pallette => {
      // console.log(pallette);
      if (this.iframeBody != null) {
        // this.setTheme(pallette);
      }

    })
    this.targetScreenWidth$ = this.layoutEditorService.getScreenWidth().pipe(takeUntil(this.destroy$)).subscribe(width => {
      this.targetScreenWidth = width;
      // console.log(this.targetScreenWidth)
    })

    /* const htmlHost = <HTMLElement>this.el.nativeElement;
    const displayContainer = <HTMLElement>htmlHost.querySelector('.display-container');
    if(displayContainer != undefined){
      const displayWidth = displayContainer.offsetWidth;
      console.log("OffsetWidth: "+displayWidth+ "ClientWidth: "+displayContainer.clientWidth);
      if(displayWidth < this.targetScreenWidth){
        const scaleRatio = displayWidth/this.targetScreenWidth;
        scaleRatio.toFixed(2)
        if(this.iframe != null){
          this.scaleIframe(scaleRatio);
        }
        console.log(this.iframe.contentWindow.document.body.scrollHeight)
      }
    } */
    this.cellLayoutThumbs$ = this.communicator.receive("cellLayoutThumbs").pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        console.log(payload)
        this.sectionEditorBridgeService.setCellLayoutOptions(payload["data"])
        /* if(payload.data.length > 0){
          console.log(payload)
          this.sectionEditorBridgeService.setCellLayoutOptions(payload.data)
        } */
      })

    this.pageBgColor$ = this.communicator.receive('pageBgColor').pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        const pageBgColor = payload.data;
      })

    this.borders$ = this.communicator.receive('borders').pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        const borders = payload.data.options
        // console.log(borders)
      })

    this.fontFamilies$ = this.communicator.receive('fontFamilies').pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        const fontFamilies = payload.data.options;
        // console.log(fontFamilies)
      })

    /* this.selectedCell$ = this.previewEditStoreService.selectedCell$.pipe(takeUntil(this.destroy$),
    tap({error: (error: Error) => console.error(error) }))
      .subscribe(data => {
        this.selectedCell = data;
        if(data != null){
          console.log({SelectedCell:data});
          this.previewEditStoreService.siteEditorConfigState$.subscribe(siteConfig => {
            console.log(siteConfig);
            this.communicator.sendFromParent({id:"siteConfig",data:siteConfig});
          })
        }
      }) */


  }
  resolveDimensions() {
    let parentHost = this.el.nativeElement.parentElement;
    while (parentHost.tagName != "BODY") {
      // console.log("It's not. It is: "+parentHost.tagName);
      parentHost = parentHost.parentElement;
    }
    if (parentHost.tagName == "BODY") {
      this.viewPortHeight = this.dimensionsService.viewPortHeight(parentHost);
    }
  }

  onLoad(iframe: HTMLIFrameElement) {
    // console.log(this.siteConfig)
    /* this.editModel$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.editState = data.editState;
      if(data.selectedSite != undefined){
        console.log("Sending selected site",data.selectedSite);
        this.communicator.sendFromParent({id:"selectedSite",data:this.selectedSite});
        console.log("Sending selected page",data.selectedPage);
        this.communicator.sendFromParent({id:"selectedPage",data:data.selectedPage});
        setTimeout(() => {
          this.selectedSite = data.selectedSite;
        }, 100);

      }
    }) */

    // this.communicator.sendFromParent({id:"siteConfig",data:this.sites});
    // this.communicator.sendFromParent({id:"selectedSite",data:this.selectedSite});

    /* this.siteConfig$ = this.previewEditStoreService.siteEditorConfigState$.pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        console.log("Does this ever happen")
        this.siteConfig = data;
        console.log(data)
        this.communicator.sendFromParent({id:"siteConfig",data:data})
      }) */
    this.iframe = iframe;
    this.resolveDimensions();
    this.iframeBody = iframe.contentDocument.body;
    this.doc = iframe.contentDocument || iframe.contentWindow;
    // console.log(this.doc);
    // console.log(iframe.contentWindow.document.body.scrollHeight);
    const htmlHost = <HTMLElement>this.el.nativeElement;
    const displayContainer = <HTMLElement>htmlHost.querySelector('.display-container');
    if (displayContainer != undefined) {
      // displayContainer.style.setProperty('height',this.viewPortHeight+"px");
      const displayWidth = displayContainer.offsetWidth;
      const displayHeight = displayContainer.offsetHeight;
      // console.log("OffsetWidth: "+displayWidth+ " OffsetHeight: "+displayHeight+" ViewPOrtHeight: "+this.viewPortHeight);
      // console.log("OffsetWidth: "+displayWidth+ "OffsetHeight: "+displayHeight);
      // this.iframe.style.height = this.iframe.contentWindow.document.body.scrollHeight+"px";
      if (displayWidth < this.targetScreenWidth) {
        const scaleRatio = displayWidth / this.targetScreenWidth;
        const heightScaleRatio = displayHeight / this.iframe.contentWindow.document.body.scrollHeight;
        // console.log(heightScaleRatio);
        scaleRatio.toFixed(2)
        if (this.iframe != null) {
          // this.scaleIframe(heightScaleRatio);
          // this.scaleIframeHeight(heightScaleRatio);
        }
        // console.log(this.iframe.contentWindow.document.body.offsetHeight)
      }
    }

    /* (<PreviewComponent>this.compRef.instance).sendCss.pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
    }) */
    // this.createComponent();

  }

  setTheme(pallette: string) {
    // console.log("What the Fok")
    this.iframeBody.className = "";
    this.iframeBody.classList.add('nb-theme-' + pallette);
    const bodyEl = <HTMLElement>this.iframeBody;
    console.log(bodyEl.offsetHeight);
  }
  scaleIframe(scaleRatio: number) {
    // console.log(this.iframe.contentWindow.document.body.scrollHeight - (this.iframe.contentWindow.document.body.scrollHeight)*(1-scaleRatio));
    // this.iframe.style.height = this.iframe.contentWindow.document.body.scrollHeight+"px";
    this.iframe.style.setProperty("transform", "scale(" + scaleRatio + ")");

  }
  scaleIframeHeight(heightScaleRatio: number) {
    this.iframe.style.setProperty("transform", "scale(0.5," + heightScaleRatio + ")");
  }
  /*   onLoad(iframe){
      console.log(iframe);
      //this.doc = iframe.contentDocument || iframe.contentWindow;
      //this.createComponent();

    } */
  createComponent() {
    // this.doc = iframe.contentDocument || iframe.contentWindow;

    // this.compRef = this.vcRef.createComponent(PreviewContentComponent);
    // this.compRef.location.nativeElement.id = 'innerComp';
    // this.iframe.classList.add
    // this.doc.body.appendChild(this.compRef.location.nativeElement);


    /* if(this.styleSheets.length > 0){
      this.styleSheets.forEach(styleSheet => {
        this.doc.head.appendChild(styleSheet);
      })
    } */
  }

  private adjustScrollForHeader(): void {
    const headerHeight = this.getActualHeaderHeight();

    // Find the layout container that needs scroll adjustment
    const layoutContainer = document.querySelector('.layout-container') as HTMLElement;

    if (!layoutContainer) {
      console.warn('Layout container not found');
      return;
    }

    // Get the current scroll position
    const currentScrollTop = layoutContainer.scrollTop || window.pageYOffset;

    // Calculate new position (move up by header height with some buffer)
    const adjustedScrollTop = Math.max(0, currentScrollTop - headerHeight - 10);

    console.log('Adjusting scroll:', {
      currentScrollTop,
      headerHeight,
      adjustedScrollTop
    });

    // Smooth scroll to adjusted position
    if (layoutContainer.scrollTo) {
      layoutContainer.scrollTo({
        top: adjustedScrollTop,
        behavior: 'smooth'
      });
    } else {
      // Fallback for older browsers
      layoutContainer.scrollTop = adjustedScrollTop;
    }
  }

  private getActualHeaderHeight(): number {
    // Get from CSS variable first
    const headerHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height');

    if (headerHeight && headerHeight !== '') {
      return parseInt(headerHeight.replace('px', ''), 0);
    }

    // Measure the actual header element
    const header = document.querySelector('nb-layout-header.fixed') as HTMLElement;
    if (header) {
      return header.offsetHeight;
    }

    // Fallback
    return 60;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
